// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Життєвий цикл застосунків» (Application Lifecycle, ключ `alm`, група `meta`). */
export const applicationLifecycleManifest: IModuleManifest = {
  key: 'alm',
  group: 'meta',
  slug: 'application-lifecycle',
  prefix: 'ALM',
  name: { en: 'Application Lifecycle', uk: 'Життєвий цикл застосунків' },
  entities: [
    { key: 'alm', slug: 'alm', name: { en: 'Application Lifecycle', uk: 'Життєвий цикл застосунків' }, main: true },
    { key: 'application_release', slug: 'application-release', name: { en: 'Application Releases', uk: 'Релізи' }, main: false },
    { key: 'application_change_request', slug: 'application-change-request', name: { en: 'Application Change Requests', uk: 'Запити на зміни' }, main: false },
    { key: 'application_environment', slug: 'application-environment', name: { en: 'Application Environments', uk: 'Середовища' }, main: false },
  ],
  loadState: () => import('./state/applicationLifecycleSlice').then((m) => m.applicationLifecycleSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
